import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import moment from "moment";
import noImage from "../../assets/images/no_image.jpg";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addOnboardedEmployee } from "../../reducers/onboardedEmployeeSlice";
import { fetchStates } from "../../reducers/stateSlice";
import districtSlice, { fetchDistricts } from "../../reducers/districtSlice";
import { fetchCities } from "../../reducers/citySlice";
import { fetchAllCities } from "../../reducers/allCitySlice";
import { fetchAllDistricts } from "../../reducers/allDistrictSlice";
import DocumentUpload from "./DocumentUpload";
import { useLoader } from "../../Loader";
import PersonalInfo from "./EmployeeOnBoard/PersonalInfo";
import AreaLocation from "./EmployeeOnBoard/AreaLocation";
import EmergencyContact from "./EmployeeOnBoard/EmergencyContact";
import OnBoardInfo from "./EmployeeOnBoard/OnBoardInfo";
import BankingInfo from "./EmployeeOnBoard/BankingInfo";

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const [formData, setFormData] = useState({
    employeeId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    roleId: "",
    departmentId: "",
    join_date: "",
    panNo: "",
    reporting_manager: [],
    probation_period: "0",
    permanentAdd: "",
    onboard_plan: [],
    training_schedule: "",
    holidayGroup: "",
    welcome_kit: [],
    it_setup: [],
    emp_handbook: "",
    emergency_contact_1: "",
    emergency_contact_2: "",
    emergency_contact_name: "",
    emergency_contact_relationship: "",
    emergency_contact_address: "",
    bank_name: "",
    bank_branch: "",
    bank_account_no: "",
    bank_ifsc_code: "",
    isActive: "",
    training_time: "",
    personalEmail: "",
    dob: null,
    pfUan: "",
    courierAdd: "",
    motherName: "",
    gender: "",
    maritalStatus: "",
    bloodGroup: "",
    // Designation: "",
    medical_disabillity: "",
    medical_disabillity_remark: "",
    eme_conteact_name2: "",
    eme_conteact_relation2: "",
    eme_conteact_add2: "",
    mobileNo: "",
    state: "",
    district: "",
    city: "",
    multi_state: [],
    multi_dis: [],
    multi_city: [],
    based_location: "",
    area_location: "",
    grade: "",
    area: "",
  });
  const dispatch = useDispatch();
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const [isCourierSameAsPermanent, setIsCourierSameAsPermanent] =
    useState(false);

  const [emergencyContactError1, setEmergencyContactError1] = useState(false);
  const [emergencyContactError2, setEmergencyContactError2] = useState(false);
  const [mobileNoError, setMobileNoError] = useState(false);
  const [tempStudentProfilePic, setTempStudentProfile] = useState(noImage);
  const [studentProfilePic, setStudentProfilePic] = useState("");
  const location = useLocation();
  const onboardedEmployees = useSelector(
    (state) => state.onboardedEmployee.onboardedEmployees
  );
  const states = useSelector((state) => state.state.states);
  const districts = useSelector((state) => state.district.districts);
  const cities = useSelector((state) => state.city.cities);
  const [docUpload, setDocUpload] = useState([]);
  const [editDocument, setEdtiDocument] = useState([]);
  const { startLoader, stopLoader } = useLoader();

  useEffect(() => {
    if (location.search == "?offer-accepted" && onboardedEmployees) {
      setFormData({
        ...formData,
        firstName: onboardedEmployees.name,
        email: onboardedEmployees.email,
        departmentId: onboardedEmployees.department_id,
        join_date: onboardedEmployees.expected_date_of_joining,
      });
    }
  }, [onboardedEmployees, location]);

  useEffect(() => {
    dispatch(fetchStates());
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    if (name === "emergency_contact_1") {
      validatedValue = value.replace(/\D/g, "");
      setEmergencyContactError1(validatedValue.length !== 10);
    } else if (name === "emergency_contact_2") {
      validatedValue = value.replace(/\D/g, "");
      setEmergencyContactError2(validatedValue.length !== 10);
    } else if (name === "mobileNo") {
      validatedValue = value.replace(/\D/g, "");
      setMobileNoError(validatedValue.length !== 10);
    } else if (name == "state") {
      dispatch(fetchDistricts(value));
    } else if (name == "district") {
      dispatch(fetchCities(value));
    }

    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
    const url = new URL(window.location);
    url.searchParams.delete("offer-accepted");
    window.history.replaceState({}, "", url);
    dispatch(addOnboardedEmployee({}));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      if (emergencyContactError1 || emergencyContactError2 || mobileNoError) {
        return;
      }
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      startLoader();
      var bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", props.rowData.id);
        bodyFormData.append("role_edit_id", props.rowData.role_edit_id);
      }
      bodyFormData.append(
        "department_manpower_id",
        onboardedEmployees ? onboardedEmployees.id : ""
      );

      bodyFormData.append("employee_photo", studentProfilePic);
      //bodyFormData.append("employeeId", "");
      bodyFormData.append("firstName", formData.firstName);
      bodyFormData.append("middleName", formData.middleName);
      bodyFormData.append("lastName", formData.lastName);
      bodyFormData.append("email", formData.email);
      bodyFormData.append("roleId", formData.roleId);
      bodyFormData.append("departmentId", formData.departmentId);
      bodyFormData.append(
        "join_date",
        moment(formData.join_date).format("YYYY-MM-DD")
      );
      bodyFormData.append("reporting_manager", formData.reporting_manager);
      bodyFormData.append("location", formData.permanentAdd);
      bodyFormData.append("onboard_plan", formData.onboard_plan);
      bodyFormData.append("training_schedule", formData.training_schedule);
      bodyFormData.append(
        "training_time",
        moment(formData.training_time).format("DD-MM-YYYY, h:mm a")
      );
      // moment(formData.training_time).format('DD-MM-YYYY, h:mm a')
      bodyFormData.append("welcome_kit", formData.welcome_kit);
      bodyFormData.append("it_setup", formData.it_setup);
      bodyFormData.append("emp_handbook", formData.emp_handbook);
      bodyFormData.append("emergency_contact", formData.emergency_contact_1);
      bodyFormData.append("bank_name", formData.bank_name);
      bodyFormData.append(
        "panNo",
        formData.panNo ? formData.panNo : "XXXPX0000X"
      );
      bodyFormData.append("bank_branch", formData.bank_branch);
      bodyFormData.append("bank_account_no", formData.bank_account_no);
      bodyFormData.append("bank_ifsc_code", formData.bank_ifsc_code);
      bodyFormData.append("isActive", formData.isActive);
      bodyFormData.append(
        "probation_period",
        formData.probation_period + "-month"
      );
      bodyFormData.append("holiday_group", formData.holidayGroup);
      bodyFormData.append("doc_submit", "");
      bodyFormData.append("pf_uan_no", formData.pfUan);
      bodyFormData.append("courierAddress", formData.courierAdd);
      bodyFormData.append("motherName", formData.motherName);
      bodyFormData.append("personal_email", formData.personalEmail);
      bodyFormData.append(
        "birth_date",
        moment(formData.dob).format("YYYY-MM-DD")
      );
      bodyFormData.append("gender", formData.gender);
      bodyFormData.append("maritalStatus", formData.maritalStatus);
      bodyFormData.append("bloodGroup", formData.bloodGroup);
      bodyFormData.append("emergencyContactNo2", formData.emergency_contact_2);
      bodyFormData.append(
        "emergencyContactNo2Name",
        formData.emergency_contact_name
      );
      bodyFormData.append(
        "emergencyRelationship",
        formData.emergency_contact_relationship
      );
      bodyFormData.append(
        "emergencyAddress",
        formData.emergency_contact_address
      );
      bodyFormData.append(
        "check_address",
        isCourierSameAsPermanent ? "1" : "0"
      );
      bodyFormData.append("designation", "");
      bodyFormData.append("medical_disability", formData.medical_disabillity);
      bodyFormData.append(
        "disability_remark",
        formData.medical_disabillity_remark
      );
      bodyFormData.append(
        "emergencyContactNo1Name",
        formData.eme_conteact_name2
      );
      bodyFormData.append(
        "emergencyContactNo2Relation",
        formData.eme_conteact_relation2
      );
      bodyFormData.append(
        "emergencyContactNo2Address",
        formData.eme_conteact_add2
      );
      bodyFormData.append("mobile_no", formData.mobileNo);
      bodyFormData.append("based_location", formData.based_location);
      bodyFormData.append("emp_state", formData.state);
      bodyFormData.append("emp_district", formData.district);
      bodyFormData.append("emp_city", formData.city);
      bodyFormData.append("area_location", formData.area_location);
      bodyFormData.append("area_state", formData.multi_state);
      bodyFormData.append("area_district", formData.multi_dis);
      bodyFormData.append("area_city", formData.multi_city);
      bodyFormData.append("grade", formData.grade);
      bodyFormData.append("emp_area", formData.area);
      Object.entries(docUpload).forEach(([id, file]) => {
        bodyFormData.append(`doc_${file.doc_id}`, file.file);
      });

      utils
        .callAPI("post", `/employee/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            const url = new URL(window.location);
            url.searchParams.delete("offer-accepted");
            window.history.replaceState({}, "", url);
            dispatch(addOnboardedEmployee({}));
            stopLoader();
          } else {
            setIsSubmit(false);
            stopLoader();
          }
        })
        .catch((err) => {
          setIsSubmit(false);
          stopLoader();
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      console.log("Edit ke ander toh gaya huin bhai..", props.rowData);
      setisEdit(true);
      const rowData = props.rowData;
      dispatch(fetchDistricts(rowData?.emp_state));
      dispatch(fetchCities(rowData?.emp_district));
      setFormData({
        employeeId: rowData.employeeId || "",
        firstName: rowData.firstName || "",
        middleName: rowData.middleName || "",
        lastName: rowData.lastName || "",
        email: rowData.email || "",
        roleId: rowData.roleId || "",
        departmentId: rowData.departmentId || "",
        join_date: new Date(rowData.join_date) || "",
        reporting_manager: rowData.reporting_manager || "",
        probation_period:
          (rowData.probation_period || "").match(/\d+/)[0] || "",
        holidayGroup: rowData.holiday_group || "",

        location: rowData.location || "",
        onboard_plan: rowData.onboard_plan || "",
        //   .split(",")
        //   .map((id) => ({ cat: id, key: `Plan ${id}` })),
        training_schedule: rowData.training_schedule || "",
        welcome_kit: rowData.welcome_kit || "",
        //   .split(",")
        //   .map((id) => ({ cat: id, key: `Welcome kit ${id}` })),
        it_setup: rowData.it_setup || "",
        //   .split(",")
        //   .map((id) => ({ cat: id, key: `it setup ${id}` })),
        emp_handbook: rowData.emp_handbook || "",
        emergency_contact: rowData.emergency_contact || "",
        bank_name: rowData.bank_name || "",
        panNo: rowData.panNo || "",
        bank_branch: rowData.bank_branch || "",
        bank_account_no: rowData.bank_account_no || "",
        bank_ifsc_code: rowData.bank_ifsc_code || "",
        isActive: rowData.isActive || "",
        training_time:
          rowData.training_time &&
          rowData.training_time !== "Invalid date" &&
          moment(
            rowData.training_time,
            ["DD-MM-YYYY, h:mm a", moment.ISO_8601],
            true
          ).isValid()
            ? moment(rowData.training_time, [
                "DD-MM-YYYY, h:mm a",
                moment.ISO_8601,
              ]).toDate()
            : null,

        personalEmail: rowData?.personal_email || "",
        dob:
          rowData.birth_date !== "0000-00-00"
            ? new Date(rowData?.birth_date)
            : "" || "",
        dob:
          rowData.birth_date !== "0000-00-00"
            ? new Date(rowData?.birth_date)
            : "" || "",
        pfUan: rowData?.pf_uan_no,
        permanentAdd: rowData?.location,
        courierAdd: rowData?.courierAddress,
        motherName: rowData?.motherName,
        gender: rowData?.gender,
        maritalStatus: rowData?.maritalStatus,
        bloodGroup: rowData?.bloodGroup,
        emergency_contact_1: rowData?.emergency_contact,
        emergency_contact_2: rowData?.emergencyContactNo2,
        emergency_contact_name: rowData?.emergencyContactNo2Name,
        emergency_contact_relationship: rowData?.emergencyRelationship,
        emergency_contact_address: rowData?.emergencyAddress,
        // Designation: rowData?.designation,
        medical_disabillity: rowData?.medical_disability,
        medical_disabillity_remark: rowData?.disability_remark,
        eme_conteact_name2: rowData?.emergencyContactNo1Name,
        eme_conteact_relation2: rowData?.emergencyContactNo2Relation,
        eme_conteact_add2: rowData?.emergencyContactNo2Address,
        mobileNo: rowData?.mobile_no,
        based_location: rowData?.based_location,
        state: rowData?.emp_state,
        district: rowData?.emp_district,
        city: rowData?.emp_city,
        area_location: rowData?.area_location,
        multi_state: rowData?.area_state,
        multi_dis: rowData?.area_district,
        multi_city: rowData?.area_city,
        grade: rowData?.grade,
        area: rowData?.emp_area,
      });
      setTempStudentProfile(rowData.profilePath);
      setIsCourierSameAsPermanent(rowData?.check_address == "1" ? true : false);
      // setOnboardPlan( rowData.onboard_plan.split(",").map(id => ({ cat: id, key: `Plan ${id}` })))
      setEdtiDocument(rowData?.employee_document);
    } else {
      console.log("Edit ke bahar aagaya huin bhai..");
      setisEdit(false);
    }
  }, [props.rowData]);

  const handleCheckboxChange = (e) => {
    setIsCourierSameAsPermanent(e.target.checked);
    if (e.target.checked) {
      setFormData({
        ...formData,
        courierAdd: formData.permanentAdd,
      });
    } else {
      setFormData({
        ...formData,
        courierAdd: "",
      });
    }
  };

  console.log(formData);
  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4>{isEdit ? "Edit" : ""}</h4>
          <div className="card-header-action">
            <Link className="btn btn-underline" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <PersonalInfo
              tempStudentProfilePic={tempStudentProfilePic}
              setTempStudentProfile={setTempStudentProfile}
              setStudentProfilePic={setStudentProfilePic}
              isEdit={isEdit}
              formData={formData}
              handleInputChange={handleInputChange}
              mobileNoError={mobileNoError}
              setFormData={setFormData}
              isCourierSameAsPermanent={isCourierSameAsPermanent}
              handleCheckboxChange={handleCheckboxChange}
            />
            <AreaLocation
              formData={formData}
              handleInputChange={handleInputChange}
              setFormData={setFormData}
              isEdit={isEdit}
              props={props}
            />
            <EmergencyContact
              formData={formData}
              handleInputChange={handleInputChange}
              setFormData={setFormData}
              emergencyContactError1={emergencyContactError1}
              emergencyContactError2={emergencyContactError2}
            />

            <OnBoardInfo
              formData={formData}
              handleInputChange={handleInputChange}
              setFormData={setFormData}
              props={props}
              isEdit={isEdit}
            />

            <BankingInfo
              formData={formData}
              handleInputChange={handleInputChange}
              setFormData={setFormData}
            />
            <DocumentUpload
              setDocUpload={setDocUpload}
              editDocument={editDocument}
            />
            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
